export const getAuthToken = (state) => state.token.token || "";

export const getMe = (state) => state.me;
